<template>
  <div >
    <div class="path">
      <i class="el-icon-caret-right"></i>账户中心
      <i class="el-icon-arrow-right"></i>&nbsp;修改密码
    </div>
    <el-main style="height: 760px;">
      <div class="main-wrapper">

        <div class="content-wrapper">

          <el-form ref="passwordForm" :model="passwordForm" :rules="passwordRules" label-width="210px">
            <div class="item-wrapper">
              <div class="item-title" style="font-size: 17px">
                <span style="color: #3888d7; font-weight: bold">|</span>
                <span style="margin-left: 2px; color: #333333">登录密码变更</span>
              </div>

              <div class="item-content">
                <el-form-item label="原密码" prop="originPassword">
                  <el-input v-model="passwordForm.originPassword" type="password"
                            placeholder="请填写原登录密码"
                            style="width: 420px">
                  </el-input>
                </el-form-item>

                <el-form-item label="新密码" prop="password">
                  <el-input v-model="passwordForm.password" type="password"
                            placeholder="请填写新的登录密码"
                            style="width: 420px"></el-input>
                </el-form-item>

                <el-form-item label="确认密码" prop="confirmPassword">
                  <el-input v-model="passwordForm.confirmPassword" type="password"
                            placeholder="请填写确认密码"
                            style="width: 420px"></el-input>
                </el-form-item>
                <div class="" style="width: 630px;">
                  <div style="width: 120px; margin-left: 510px;">
                    <el-button type="danger" style="width: 120px;"
                               @click="submitPassword">提 交
                    </el-button>
                  </div>
                </div>
              </div>
            </div>
          </el-form>

          <br>
        </div>
      </div>
    </el-main>
  </div>
</template>

<script>
import {
  reqUpdatePassword
} from '@/api'

export default {
  name: 'UpdatePassword',

  data () {
    // 校验确认密码
    const checkConfirmPassword = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请填写确认密码'))
      }
      if (value.trim().length < 8) {
        return callback(new Error('密码长度不少于8位'))
      }
      if (value.trim() != this.passwordForm.password.trim()) {
        return callback(new Error('确认密码与密码不一致'))
      }
      callback()
    }

    return {
      passwordForm: {
        originPassword: '', // 原登录密码
        password: '', // 密码
        confirmPassword: '' // 确认密码
      },
      passwordRules: {
        originPassword: [
          { required: true, message: '请填写原密码', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请填写新密码', trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, validator: checkConfirmPassword, trigger: 'blur' }
        ]
      },
    }
  },

  methods: {
    // 处理更新密码事件
    submitPassword () {
      this.$refs.passwordForm.validate(async (valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '提交中',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })
          const result = await reqUpdatePassword(this.passwordForm.originPassword, this.passwordForm.password)
          loading.close()
          await this.$alert(`${ result.message }`, '提示', {
            confirmButtonText: '确定',
            callback: action => {
            }
          })
          if (result.code === 0) {
            this.$refs.passwordForm.resetFields()
          }
        } else {
          await this.$alert('输入信息不正确，请完善后再提交！', '提示', {
            confirmButtonText: '确定',
            callback: action => {
            }
          })
          return false
        }
      })
    },

  },

  computed: {

  }
}
</script>

<style scoped>
  .path {
    height: 40px;
    line-height: 40px;
    padding-left: 16px;
    font-size: 14px;
    color: #666;
  }
</style>



// WEBPACK FOOTER //
// src/pages/CustomerCenter/UpdatePassword/UpdatePassword.vue